import lazyScreen from '../utils/lazyScreen';
const AIJobQueues = lazyScreen(() => import('../pages/ai/AIJobQueues/index.js'), 'pages/ai/AIJobQueues/index.js');
const AIJobQueue = lazyScreen(() => import('../pages/ai/AIJobQueue/index.js'), 'pages/ai/AIJobQueue/index.js');
const AIDocumentSources = lazyScreen(() => import('../pages/ai/AIDocumentSources/index.js'), 'pages/ai/AIDocumentSources/index.js');
const AIDocumentSource = lazyScreen(() => import('../pages/ai/AIDocumentSource/index.js'), 'pages/ai/AIDocumentSource/index.js');
const AIKnowledgeBases = lazyScreen(() => import('../pages/ai/AIKnowledgeBases/index.js'), 'pages/ai/AIKnowledgeBases/index.js');
const AIKnowledgeBase = lazyScreen(() => import('../pages/ai/AIKnowledgeBase/index.js'), 'pages/ai/AIKnowledgeBase/index.js');
const AIWorkspace = lazyScreen(() => import('../pages/ai/AIWorkspace/index.js'), 'pages/ai/AIWorkspace/index.js');
const AIImportBatchs = lazyScreen(() => import('../pages/ai/AIImportBatchs/index.js'), 'pages/ai/AIImportBatchs/index.js');
const AIImportBatch = lazyScreen(() => import('../pages/ai/AIImportBatch/index.js'), 'pages/ai/AIImportBatch/index.js');

export default [
    {
        path: '/ai/AIWorkspace',
        component: AIWorkspace
    },
    {
        path: '/ai/AIJobQueues',
        component: AIJobQueues
    },
    {
        path: '/ai/AIJobQueue/:code',
        component: AIJobQueue
    },
    {
        path: '/ai/AIDocumentSources',
        component: AIDocumentSources
    },
    {
        path: '/ai/AIDocumentSource/:code',
        component: AIDocumentSource
    },
    {
        path: '/ai/AIKnowledgeBases',
        component: AIKnowledgeBases
    },
    {
        path: '/ai/AIKnowledgeBase/:code',
        component: AIKnowledgeBase
    },
    {
        path: '/ai/AIImportBatchs',
        component: AIImportBatchs
    },
    {
        path: '/ai/AIImportBatch/:code',
        component: AIImportBatch
    }
];
